import { ColorsEnum } from "../../../../../../core/et3-theme/colors";

const ALPHA_MODERATION_SOFT = "14";

export const MODERATION_SOFT_CRITICAL = `${ColorsEnum.red}${ALPHA_MODERATION_SOFT}`;
export const MODERATION_SOFT_WARNING = `${ColorsEnum.darkOrange}${ALPHA_MODERATION_SOFT}`;
export const MODERATION_SOFT_POSITIVE = `${ColorsEnum.green}${ALPHA_MODERATION_SOFT}`;
export const MODERATION_SOFT_INFO = `${ColorsEnum.blue}${ALPHA_MODERATION_SOFT}`;
export const MODERATION_SOFT_NEUTRAL = ColorsEnum.paleGrayishWhite;
